import React from "react";
import UsageHistoryDashboard from "../dashboard/dashboard";
import { Card } from "@shared/ui/card";
import WorkflowCard from "@features/ux/components/shared/components/workflowCard";
import HistoryList from "../historyList/historyList";
import { useParams } from "react-router-dom";

const UsageHistoryLanding = () => {
  const {id} = useParams()
  return (
    <div>
      <Card>
        <UsageHistoryDashboard />
      </Card>
      <WorkflowCard source={1} sourceId={Number(id)} sourceName="recipient-lists"/>
      <Card className="mt-4">
        <HistoryList/>
      </Card>
    </div>
  );
};

export default UsageHistoryLanding;
